import React from "react";
import dynamic from "next/dynamic";
import { makeYourTubeEmbed } from "helpers/video";

const Player = dynamic(() => import("components/Videos/SingleVideo/Player"), {
  ssr: false,
});

function EmbededVideo({ video, title }) {
  return (
    <Player
      light={false}
      videoId={makeYourTubeEmbed(video.url, video.trailer)}
      title={title}
    />
  );
}

export default EmbededVideo;
